import { Stack } from '@mui/material';
import Box from '@mui/material/Box';
import { BrowserRouter as Router } from 'react-router-dom';

import { useMediaQuery } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, createTheme } from '@mui/material/styles';

// components
import MainBanner from './MainBanner2';

// footer
import Footer from './Footer';

// nav_bar
import NavBar from '../../Nav_Bar/index';


function App() {
  
  const theme = createTheme(); // Create a default MUI theme
  // Use Material-UI's useMediaQuery hook to determine screen size
  const isMobile = useMediaQuery('(max-width:600px)'); // true if screen width is 600px or less

  return (
      <Box>
        <Stack direction="column" spacing={0}>
        <ThemeProvider theme={theme}>
        <CssBaseline />
          <NavBar />
          <MainBanner />
          <Footer/>
        </ThemeProvider>
        </Stack>
      </Box>
  );
}

export default App;
